const INTERNAL_ORIGIN = 'https://internal.invalid';

export function safeInternalPath(value?: string | null): string | null {
  if (!value || !value.startsWith('/')) return null;

  try {
    const url = new URL(value, INTERNAL_ORIGIN);

    if (url.origin !== INTERNAL_ORIGIN) return null;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
